// extracted by mini-css-extract-plugin
export default {"small":"Text_small__y-ddF","medium":"Text_medium__OScI9","large":"Text_large__2UCbI","huge":"Text_huge__A80A9","bold":"Text_bold__XB+1w"};